 <template>
    <Toast />
    <div class="chequeosStatusBar">
        <strong>Último chequeo: </strong> <span class="ultimoChequeoHora">{{ ultimoChequeoHora }}</span>
        <ProgressSpinner class="chequeandoSpinner" strokeWidth="8" fill="#eee" animationDuration="1.5s" v-if="chequeando" />
        <span class="chequeandoAviso" v-if="chequeando">Chequeando ...</span>
    </div>
    <div class="p-grid p-mt-5">
        <div v-for="consumo in consumos" :key="consumo.id" class="p-col-12 p-xl-6 p-lg-6">
            <Card class="usuario-card p-shadow-2" :class="{ cancelado: consumo.estado === -1, guardado: consumo.estado === 2 }">
                <template #title>
                    {{ consumo.usuario.nombre }} {{ consumo.usuario.apellido }}
                    <Button
                        icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text p-button-lg"
                        @click="cancelarConsumo(consumo)"
                        :disabled="consumo.autorizando || consumo.guardando"
                /></template>
                <template #subtitle> {{ consumo.estado === 0 ? 'Pre autorizar monto' : 'Monto consumido' }}: </template>
                <template #content>
                    <div class="p-fluid">
                        <div class="p-field" v-if="consumo.estado === 0">
                            <label>&nbsp;</label>
                            <InputNumber
                                class="p-inputtext-lg"
                                id="autorizado"
                                v-model="consumo.autorizado"
                                mode="currency"
                                currency="ARS"
                                locale="es-AR"
                                :maxFractionDigits="0"
                            />
                            <Button
                                :label="consumo.autorizando ? 'Pre Autorizando ...' : 'Pre Autorizar'"
                                @click="preAutorizar(consumo)"
                                class="pre-autorizar p-mt-3"
                                :loading="consumo.autorizando"
                            />
                            <small>ID #{{ consumo.id }}</small>
                            <!-- <small class="p-error" v-for="error of v$.usuario.credito_mensual.$errors" :key="error.$uid">{{ error.$message }}</small> -->
                        </div>
                        <div class="p-field" v-if="consumo.estado === 1">
                            <label><strong>Monto pre autorizado:</strong> ${{ consumo.autorizado.toLocaleString('es-ar') }}</label>
                            <InputNumber
                                class="p-inputtext-sm"
                                id="monto"
                                v-model="consumo.monto"
                                mode="currency"
                                currency="ARS"
                                locale="es-AR"
                                :maxFractionDigits="0"
                            />
                            <Button
                                :label="consumo.guardando ? 'Guardando ...' : 'Guardar'"
                                @click="guardar(consumo)"
                                class="guardar p-mt-3"
                                :loading="consumo.guardando"
                            />
                            <small>ID #{{ consumo.id }}</small>
                            <!-- <small class="p-error" v-for="error of v$.usuario.credito_mensual.$errors" :key="error.$uid">{{ error.$message }}</small> -->
                        </div>
                        <div class="p-field" v-if="consumo.estado === 2">
                            <label>&nbsp;</label>
                            <InputNumber
                                class="p-inputtext-sm"
                                id="monto"
                                v-model="consumo.monto"
                                mode="currency"
                                currency="ARS"
                                locale="es-AR"
                                :maxFractionDigits="0"
                            />
                            <Button label="Guardado" :disabled="true" class="guardar p-mt-3" />
                            <small>ID #{{ consumo.id }}</small>
                        </div>
                        <div class="p-field" v-if="consumo.estado === -1">
                            <label>&nbsp;</label>
                            <InputNumber
                                class="p-inputtext-sm"
                                id="monto"
                                modelValue="0"
                                mode="currency"
                                currency="ARS"
                                locale="es-AR"
                                :maxFractionDigits="0"
                            />
                            <Button label="Cancelado" :disabled="true" class="guardar p-mt-3" />
                            <small>ID #{{ consumo.id }}</small>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
    <Dialog v-model:visible="mostrarQR" :style="{ width: '450px' }" header="Código QR" :modal="true">
        <div class="qr-container">
            <div class="qr" ref="qr"></div>
        </div>
    </Dialog>
</template>

<script>
import moment from 'moment'
import { sleep } from '../../resources/helpers'
import ConsumosService from '../../service/ConsumosService'
import QRCode from 'qrcode-svg'
import EventBus from '@/AppEventBus'
import { mapGetters } from 'vuex'

export default {
    name: 'InicioProveedoresPDV',
    data() {
        return {
            chequeoTimer: null,
            chequeando: false,
            consumos: [],
            ultimoChequeoHora: '-',
            mostrarQR: false,
        }
    },
    mounted() {
        this.chequearConsumo()
        this.chequeoTimer = setInterval(() => {
            this.chequearConsumo()
        }, 5000)

        EventBus.on('ver-qr', this.verQR)
    },
    unmounted() {
        clearInterval(this.chequeoTimer)
    },
    computed: {
        ...mapGetters('auth', ['pdvActual']),
    },
    methods: {
        verQR() {
            this.mostrarQR = true

            setTimeout(() => {
                var qrcode = new QRCode({ content: this.pdvActual.uid, join: true, width: 398, height: 398, padding: 2, background: '#f0f0f0' })
                this.$refs.qr.innerHTML = qrcode.svg()
            }, 500)
        },
        async cancelarConsumo(consumo) {
            consumo.autorizando = true
            consumo.guardando = true

            const respuesta = await ConsumosService.update({
                id: consumo.id,
                estado: -1,
            })

            if (respuesta.success === true) {
                this.$toast.add({ severity: 'success', summary: 'Listo!', detail: 'El consumo ha sido cancelado.', life: 5000 })
                consumo.estado = -1
                setTimeout(() => {
                    this.consumos = this.consumos.filter((_consumo) => _consumo.id !== consumo.id)
                }, 5000)
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'El consumo no se canceló.', life: 5000 })
            }

            consumo.autorizando = false
            consumo.guardando = false
        },
        async quitarConsumo(consumoId) {
            this.consumos = this.consumos.filter((_consumo) => _consumo.id !== consumoId)
        },
        async chequearConsumo() {
            this.chequeando = true
            await sleep(1000)

            const consumos = (await ConsumosService.get({})).consumos

            consumos.map((consumo) => {
                if (typeof this.consumos.find((_consumo) => _consumo.id === consumo.id) === 'undefined') {
                    if (consumo.estado >= 0 && consumo.estado < 2) {
                        consumo.autorizando = false
                        consumo.guardando = false
                        this.consumos.push(consumo)
                    }
                }
            })

            this.ultimoChequeoHora = moment().format('HH:mm:ss')

            this.chequeando = false
        },
        async preAutorizar(consumo) {
            if (consumo.autorizado <= 0) {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'El monto a autorizar debe ser mayor a CERO.', life: 5000 })
                return
            }

            consumo.autorizando = true

            const respuesta = await ConsumosService.update({
                id: consumo.id,
                autorizado: consumo.autorizado,
            })

            if (respuesta.success === true) {
                this.$toast.add({ severity: 'success', summary: 'Listo!', detail: 'El monto ha sido autorizado.', life: 5000 })
                consumo.estado = respuesta.consumo.estado
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'El monto no está autorizado.', life: 5000 })
            }

            consumo.autorizando = false
        },
        async guardar(consumo) {
            if (consumo.monto <= 0) {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'El monto consumido debe ser mayor a CERO.', life: 5000 })
                return
            }

            consumo.guardando = true

            const respuesta = await ConsumosService.update({
                id: consumo.id,
                monto: consumo.monto,
            })

            if (respuesta.success === true) {
                this.$toast.add({ severity: 'success', summary: 'Listo!', detail: 'El monto consumido ha sido guardado.', life: 5000 })
                consumo.estado = respuesta.consumo.estado

                setTimeout(() => {
                    this.quitarConsumo(consumo.id)
                }, 10000)
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'El monto consumido no puede ser superior al autorizado.', life: 5000 })
            }
            consumo.guardando = false
        },
    },
}
</script>

<style lang="scss" scoped>
.usuario-card {
    border-radius: 20px;

    &.guardado {
        background-color: rgba($color: #00ff00, $alpha: 0.05);

        ::v-deep(.p-card-body) {
            padding-bottom: 0;

            .p-card-title {
                .p-button-rounded {
                    display: none;
                }
            }

            .p-inputtext {
                pointer-events: none;
            }
        }
    }

    &.cancelado {
        background-color: rgba($color: #ff0000, $alpha: 0.1);

        ::v-deep(.p-card-body) {
            padding-bottom: 0;

            .p-card-title {
                .p-button-rounded {
                    display: none;
                }
            }

            .p-inputtext {
                pointer-events: none;
            }
        }
    }

    ::v-deep(.p-card-body) {
        padding-bottom: 0;

        .p-card-title {
            color: #381f43;
            font-size: 36px;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            padding-right: 28px;

            .p-button-rounded {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .p-card-subtitle {
            color: #777777;
            font-size: 24px;
            font-weight: 500;
        }
        .p-inputtext {
            color: #777777;
            font-size: 30px;
            font-weight: 500;
            padding: 0.5rem 1rem;
            border-radius: 10px;
        }
        .p-card-content {
            padding-bottom: 0.1rem;

            .p-button {
                &.pre-autorizar {
                    background-color: #381f43;
                }
                &.guardar {
                    background-color: #d69e3c;
                }
                border-radius: 10px;
                font-size: 30px;
                font-weight: 500;
                text-transform: uppercase;
                padding: 0.5rem;
            }
        }
    }
}
h2 {
    font-size: 36px;
    text-transform: uppercase;
    margin-bottom: 4px;
}
.chequeosStatusBar {
    width: 100%;
    height: 36px;
    position: absolute;
    top: 50px;
    left: 0;
    line-height: 36px;
    margin-top: 0;
    margin-bottom: 30px;
    background-color: #e6e6e6;
    border-bottom: 1px solid #666;
    z-index: 1;
    text-align: left;
    padding-left: 16px;
}
.chequeandoSpinner {
    width: 18px;
    height: 18px;
    margin-left: 10px;
}
.chequeandoAviso {
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
    vertical-align: 2px;
    display: inline-block;
}

.ultimoChequeoHora {
    color: #666;
}

@media screen and (max-width: 40em) {
    .usuario-card {
        border-radius: 10px;

        ::v-deep(.p-card-body) {
            .p-card-title {
                font-size: 20px;

                .p-button-rounded {
                    width: 1.5rem !important;
                    height: 1.5rem !important;
                    padding: 0 !important;
                }
            }
            .p-card-subtitle {
                font-size: 18px;
            }
        }
    }
}
</style>
